import { connect } from 'react-redux';
import { selectLocaleData } from 'selectors/locale-data';
import ScheduleRecurrenceDays from './ScheduleRecurrenceDays';

export const mapStateToProps = (state, ownProps) => {
  const { startWeekOn } = selectLocaleData(state);

  return {
    ...ownProps,
    startWeekOn,
  };
};

export default connect(mapStateToProps)(ScheduleRecurrenceDays);
